const poiImages = {
  sailflow: 'https://cdn-consumer.weatherflow.com/images/markers/poi/sailflow-poi@2x.png?051226a',
  ikitesurf: 'https://cdn-consumer.weatherflow.com/images/markers/poi/kitesurf-poi@2x.png?051226a',
  iwindsurf: 'https://cdn-consumer.weatherflow.com/images/markers/poi/windsurf-poi@2x.png?051226a',
  fishweather: 'https://cdn-consumer.weatherflow.com/images/markers/poi/fishweather-poi@2x.png?051226a',
  windalert: 'https://cdn-consumer.weatherflow.com/images/markers/poi/windalert-poi@2x.png?051226a'
}

export default (urlParameters) => {
  const { brand } = urlParameters
  const poiImage = brand ? poiImages[brand.toLowerCase()] : null

  jweather.poiImage = poiImage
  jweather.primaryActivity = jweather.primaryActivity?.toLowerCase() || null

  jweather.invalidToken = function (statusCode, statusMessage) {
    console.log('Invalid token handler: ' + statusCode + ' ' + statusMessage)
  }

  jweather.membershipRequired = function (feature) {
    console.log('Membership required for this feature: ')
    alert('Membership required for this feature: ')
  }
}
